export const IMPORT_HISTORY_WARNING =
  "PO Details were saved, but import history could not be finalized. IT attention is required.";

export const saveImportedPoDetails = async ({ persistRemote, reloadPoTrackerAfterSave, dataset, meta, sourceFilename }) => {
  const payload = await persistRemote(dataset, meta, { sourceFilename });
  await reloadPoTrackerAfterSave();
  const needsImportHistoryWarning =
    payload?.partialSuccess === true || payload?.warningCode === "import_history_finalization_failed";
  return needsImportHistoryWarning ? IMPORT_HISTORY_WARNING : "";
};
